import React from 'react'

import TableRowActions from '@/app/component/layout/table/actions'
import { TCampaignListItem } from '@/app/module/campaigns/types'

type Props = {
  actions: Record<string, () => void>
  data: TCampaignListItem
}

const getPublishConfig = (data: TCampaignListItem, actions: Record<string, () => void>) => {
  if (!data.state.launched && !data.state.aborted) {
    return {
      icon: 'power_settings_new',
      label: !data.state.published ? 'Set Live' : 'Stop campaign',
      onClick: !data.state.published ? actions.publish : actions.unpublish,
    }
  }

  if (data.state.launched && !data.state.aborted) {
    return {
      icon: 'power_off',
      label: 'Stop',
      onClick: actions.abort,
    }
  }

  return {
    disabled: true,
    icon: 'power_settings_new',
    label: 'Stopped',
    onClick: () => {},
  }
}

const getArchiveConfig = (data: TCampaignListItem, actions: Record<string, () => void>) => {
  if (!data.state.archived) {
    return {
      icon: 'archive',
      label: 'Archive',
      onClick: actions.archive,
    }
  }
  return {
    icon: 'unarchive',
    label: 'Unarchive',
    onClick: actions.unarchive,
  }
}

const getOpenConfig = (data: TCampaignListItem, actions: Record<string, () => void>) => {
  if (data.open) {
    return {
      disabled: data.state.aborted || !data.state.launched,
      icon: 'lock',
      label: 'Disable new subscriptions',
      onClick: actions.close,
    }
  }

  return {
    disabled: data.state.aborted || !data.state.launched,
    icon: 'lock_open',
    label: 'Enable new subscriptions',
    onClick: actions.open,
  }
}

const getCopyConfig = (data: TCampaignListItem, actions: Record<string, () => void>) => ({
  icon: 'content_copy',
  label: 'Duplicate',
  onClick: actions.copy,
})

const getCopyIdConfig = (data: TCampaignListItem, actions: Record<string, () => void>) => ({
  icon: 'money',
  label: `Copy ID (${data.id})`,
  onClick: actions.copyId,
})

const getEditConfig = (data: TCampaignListItem, actions: Record<string, () => void>) => {
  if (data.state.launched) {
    return [
      {
        disabled: data.state.aborted,
        icon: 'input',
        label: 'Manage subscriptions',
        onClick: actions.manage,
      },
      {
        disabled: data.state.aborted,
        icon: 'stop',
        label: 'Unsubscribe all',
        onClick: actions.stopAll,
      },
      {
        disabled: data.state.aborted,
        icon: 'create',
        label: 'Edit',
        onClick: actions.edit,
      },
    ]
  }

  if (data.state.published && !data.state.aborted) {
    return [
      {
        icon: 'create',
        label: 'Return to draft',
        onClick: actions.unpublishThenEdit,
      },
    ]
  }

  return [
    {
      disabled: data.state.aborted,
      icon: 'create',
      label: 'Edit',
      onClick: actions.edit,
    },
  ]
}

const getCampaignReportConfig = (data: TCampaignListItem, actions: Record<string, () => void>) => ({
  disabled: !data.state.launched,
  icon: 'bar_chart',
  label: 'Download report (Excel)',
  onClick: actions.downloadCampaignReport,
})

const Actions: React.FC<Props> = ({ actions, data }) => {
  return (
    <TableRowActions
      config={[
        ...getEditConfig(data, actions),
        getCampaignReportConfig(data, actions),
        getCopyConfig(data, actions),
        getOpenConfig(data, actions),
        getCopyIdConfig(data, actions),
        getPublishConfig(data, actions),
        getArchiveConfig(data, actions),
      ]}
    />
  )
}

export default Actions
